import { render } from "./ImageBar.vue?vue&type=template&id=0ab62483&scoped=true"
import script from "./ImageBar.vue?vue&type=script&lang=js"
export * from "./ImageBar.vue?vue&type=script&lang=js"

import "./ImageBar.vue?vue&type=style&index=0&id=0ab62483&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab62483"]])

export default __exports__